<template>
  <div class="chart">
    <div ref="barChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "staBarView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    barWidth: {
      type: String,
      default: "14px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "canvas",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$refs.barChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", this.handleClick);
    },
    initChartOption() {
      const _this = this;
      this.chart.setOption({
        // dataZoom: [
        //   {
        //     type: "inside",
        //     realtime: true,
        //     start: 80,
        //     end: 100,
        //   },
        //   {
        //     show: true,
        //     xAxisIndex: [0],
        //     realtime: true,
        //     height: 4, //这里可以设置dataZoom的尺寸
        //     bottom: "2%",
        //     backgroundColor: "#1d76e6", // 填充颜色
        //     textStyle: {
        //       color: "#fff", // 左右两边文字颜色
        //     },
        //   },
        // ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.63)", //设置背景颜色
          textStyle: {
            color: "#fff",
          },
          borderColor: "rgba(255,255,255, .5)",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}季度<br>牛：{c}<br>羊：{c1}<br>家禽{c2}<br>其他{c3}",
        },
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        legend: {
          data: ["牛", "羊", "家禽", "其他"],
          icon: "",
          right: "2%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          itemWidth: 20,
          itemHeight: 7,
          itemGap: 35,
          color: "#fff",
          // selectedMode: false,
        },
        xAxis: {
          type: "category",
          name: "季度",
          data: _this.data.month,
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(45, 60, 92, 1)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontFamily: "Microsoft YaHei",
            color: "#b5dbff", // x轴颜色
            fontWeight: "normal",
            fontSize: "14",
            lineHeight: 22,
            interval: 0, //标签设置为全部显示
            // lineHeight: 15,
          },
        },

        yAxis: [
          {
            min: 0,
            type: "value",
            name: "头",
            nameTextStyle: {
              color: "#b5dbff",
              fontSize: "14px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, 1)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, .3)", //左侧显示线
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#b5dbff",
              fontSize: 12,
            },
          },
        ],
        series: [
          /*  // 牛中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-25, -4],
                        symbolPosition: "end",
                        z: 12,
                        color: "#00DEFF",
                        data: _this.data.cattleCount,
                    },
                    // 羊中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-8, -4],
                        symbolPosition: "end",
                        z: 12,
                        color: "#fcab2b",
                        data: _this.data.sheepCount,
                    },
                    //家禽中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [8, -4],
                        symbolPosition: "end",
                        z: 12,
                        color: "#01cc67",
                        data: _this.data.poultryCount,
                    },
                    //其他中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [25, -4],
                        symbolPosition: "end",
                        z: 12,
                        color: "#a867e6",
                        data: _this.data.otherCount,
                    }, */
          /*  //  牛正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-25, 0],
                        z: 12,
                        color: "rgba(0, 187, 233, 0.1)",
                        data: _this.data.cattleCount,
                    },
                    // 羊正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-8, 0],
                        color: "rgba(252,171,43,0.1)",
                        z: 12,
                        data: _this.data.sheepCount,
                    },
                    // 家禽底部正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [8, 0],
                        color: "rgba(1,204,103,0.1)",
                        z: 12,
                        data: _this.data.poultryCount,
                    },
                    // 其他底部正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [26, 0],
                        color: "rgba(168,103,230,0.1)",
                        z: 12,
                        data: _this.data.otherCount,
                    }, */
          // 牛进度柱子
          {
            name: "牛",
            type: "bar",
            barWidth: _this.barWidth,
            // zlevel: 2,
            stack: "1",
            itemStyle: {
              opacity: 0.7,
              color: "#00DEFF",
            },
            label: {
              show: false,
              position: ["-18", "-18"],
              color: "#00DEFF",
              fontSize: 12,
            },
            data: _this.data.cattleCount,
          },

          // 羊进度柱子
          {
            name: "羊",
            type: "bar",
            stack: "2",
            barWidth: _this.barWidth,
            itemStyle: {
              opacity: 0.7,
              color: "#fcab2b",
            },
            label: {
              show: false,
              position: ["18", "-18"],
              color: "#fcab2b",
              fontSize: 12,
            },
            data: _this.data.sheepCount,
          },
          // 家禽进度柱子
          {
            name: "家禽",
            type: "bar",
            stack: "3",
            barWidth: _this.barWidth,
            itemStyle: {
              opacity: 0.7,
              color: "#01cc67",
            },
            label: {
              show: false,
              position: ["18", "-18"],
              color: "#01cc67",
              fontSize: 12,
            },
            data: _this.data.poultryCount,
          },
          // 其他进度柱子
          {
            name: "其他",
            type: "bar",
            stack: "4",
            barWidth: _this.barWidth,
            itemStyle: {
              opacity: 0.7,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#a867e6",
                },
                {
                  offset: 1,
                  color: "#a867e6",
                },
              ]),
              borderRadius: 0,
            },
            label: {
              show: false,
              position: ["18", "-18"],
              color: "#a867e6",
              fontSize: 12,
            },
            data: _this.data.otherCount,
          },
        ],
      });
    },
    handleClick(params) {
      this.$emit("click", params);
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>